// src/lib/wbs/progressService.ts (DB 어댑터만 잔존)
import { toISODate } from '../../utils/date';
import {
    submitProgress, // POST submit (nodeId, weekOf, earnedValue)
    approveSubmission, // POST approve by submissionId
    rejectSubmission, // POST reject by submissionId
    listFlags as apiListFlags,
    listProgressHistory as apiListHistory,
} from '../../features/wbs/api';

type WeekOfInput = string | Date;

function toWeekOfISO(v: WeekOfInput): string {
    return typeof v === 'string' ? v : toISODate(v);
}

export type ProgressStatus = 'PENDING' | 'APPROVED' | 'REJECTED';

// EV 제출 (nodeId 기준)
export async function upsertDraftByNodeId(
    projectId: string,
    weekOf: WeekOfInput,
    nodeId: string,
    ev: number,
    listVersionUsed?: number,
) {
    const weekOfISO = toWeekOfISO(weekOf); // 'YYYY-MM-DD'
    return await submitProgress(projectId, nodeId, weekOfISO, ev, listVersionUsed);
}

// ✅ 배치 승인/반려는 “제출 ID들”을 서버에 그대로 전달만
export async function approveBatch(projectId: string, submissionIds: string[]) {
    await Promise.all(submissionIds.map((id) => approveSubmission(projectId, id)));
}

export async function rejectBatch(
    projectId: string,
    items: Array<{ submissionId: string; expectedEarnedValue: number; reason?: string; }>,
    reason?: string,
) {
    await Promise.all(
        items.map(({ submissionId, expectedEarnedValue, reason }) =>
            rejectSubmission(projectId, submissionId, { reason, expectedEarnedValue }),
        ),
    );
}

// 주간 플래그 (서버 계산)
export async function listFlags(projectId: string, weekOf: WeekOfInput, nodeIds: string[]) {
    const weekOfISO = toWeekOfISO(weekOf);
    return await apiListFlags(projectId, weekOfISO, nodeIds);
}

// 히스토리 (서버 조회; nodeId 기준)
export async function fetchProgressHistory(projectId: string, nodeId: string) {
    return await apiListHistory(projectId, nodeId);
}
